import { Box, ButtonBase, useTheme } from "@mui/material";
import { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

import { relationReturnsDesignConfig } from "./relationReturnsDesignConfig";

import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import Vormgeving from "./views/Vormgeving";
import { useGetRelationForMenuQuery, useUpdatePortalstyleMutation } from "../../../../newapi/global/relation/relationSlice";
import { tokens } from "../../../../theme";
import { transformMap } from "../../../../components/portalbuilder/componentMaps";
import { showToastMessageRequestError, showToastMessageUpdateRequest } from "../../../../utils/toasts";
import TabView3 from "../../../../components/theme/TabView3/TabView3";
import Text from "../../../../components/theme/text/Text";
import { ShCopyButtonWithOwnChildren } from "../../../../components/theme/ShCopy";
import PortalSettings from "./views/PortalSettings";
import {defaultStyleMap} from './defaultStyleMap';
import ReturnReasons from "./views/ReturnReasons";
import ReturnCosts from "./views/ReturnCosts";

const ReturnPortalDesignWarehouse = (props) => {
    const { t,i18n } = useTranslation();

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    // Warehouse manages its own single return portal, stored under relation 1.
    const {data, isLoading, isFetching} = useGetRelationForMenuQuery(1);
    const [transformedData, setTransformedData] = useState(null);
    const [updatePortalstyle,{isLoading:styleUpdating}] = useUpdatePortalstyleMutation();


    useEffect(() => {
      if (!isLoading && !isFetching) {
            if(data?.portalStyle){
                setTransformedData(transformMap(data?.portalStyle));
            } else {
                setTransformedData(defaultStyleMap);
            }
      }
    }, [isLoading, isFetching]);


    const saveDesign = async (key,map) => {
        try{
            if(styleUpdating) return;
            const newMap = {...transformedData};

            const resp = await updatePortalstyle({
                style: newMap,
            })
            .unwrap();
            showToastMessageUpdateRequest(t,resp);
        }catch(error){
            showToastMessageRequestError(t("save_design_error"),t,error);
        }
    }


    return (
        <Box sx={{background:"", width:1,paddingTop:9}}>
            <Box
                sx={{
                    background:colors.bg["tertiary"],
                    // background:'orange',
                    px:4,
                    width:1,
                    pt:1,
                    pb:3,
                    display:'flex',
                    gap:2,
                }}
            >
                <Box
                    sx={{
                        borderRadius:5,
                        height:40,
                        // background:"orange",
                        background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[0],
                        border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                        boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                        width:1,
                        flex:1,
                        lineHeight:"40px",
                        pl:2.5,
                        display:'flex',
                    }}
                >
                    <Text bold>
                        {"https://www.clicktoreturn.com/"+data?.portalCode}
                    </Text>

                    <ShCopyButtonWithOwnChildren
                        value={"https://www.clicktoreturn.com/"+data?.portalCode}

                        sx={{
                            ml:"auto",
                            alignItems:"center",
                            pr:0.5,
                            // height:40,
                            // px:2,
                            // color:colors.txt["primary"],
                        }}
                    >
                        <ButtonBase
                            sx={{
                                height:32,
                                borderRadius:5,
                                px:2,
                                display:"flex",
                                alignItems:"center",
                                justifyContent:'center',
                                background: theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400],
                                color: theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt["light"],
                                fontSize:14,
                                fontWeight:700,
                                fontFamily:"Roboto, sans-serif",
                            }}
                        >
                            {t("copy_link")}
                        </ButtonBase>
                    </ShCopyButtonWithOwnChildren>
                </Box>
                <ButtonBase
                    onClick={() => {
                        if(data) {
                            const href = "https://www.clicktoreturn.com/"+data?.portalCode;
                            window.open(href, '_blank'); // Opens in new tab
                        }
                    }}
                    sx={{
                        height:40,
                        borderRadius:5,
                        px:2,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:'center',
                        background: theme.palette.mode === "dark" ? colors.grey[800] : colors.grey[400],
                        color: theme.palette.mode === "dark" ? colors.txt["light"] : colors.txt["light"],
                        fontSize:14,
                        fontWeight:700,
                        fontFamily:"Roboto, sans-serif",
                    }}
                >
                    <Box sx={{width:24,mr:4}}></Box>
                    {t("view_portal")}
                    <OpenInNewOutlinedIcon sx={{ml:3,color:colors.txt["softened"]}} />
                </ButtonBase>

            </Box>

            <TabView3
                tabConfig={relationReturnsDesignConfig}
                // viewType="bodytabs"
                    sx={{
                        background:"green",
                        // minHeight:"calc(100%)",
                        // height: 'calc(100vh - 182px)',
                        minHeight:"calc(100% - 72px)",
                        background: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                        position:"relative",
                        zIndex:2,
                        display:"flex",
                        flexDirection:"column",

                        "&:before" : {
                            content: "''",
                            display:"block",
                            width:"32px",
                            height:"32px",
                            position:"absolute",
                            left:0,
                            top:0,
                            zIndex:1,
                            backgroundColor: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                            top:"40px",
                            height:"48px",
                            width:"24px",
                            borderTopLeftRadius:"24px",
                            boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                            transition:"250ms"
                        },

                        "&:after" : {
                            content: "''",
                            display:"block",
                            width:"32px",
                            height:"32px",
                            position:"absolute",
                            top:0,
                            zIndex:1,
                            backgroundColor: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                            top:"40px",
                            right:0,
                            height:"48px",
                            width:"24px",
                            borderTopLeftRadius:"24px",
                            boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                            transform:"scaleX(-1)",
                            transition:"250ms"
                        },

                        "@media screen and (max-width: 47.9375em)" : {
                            "&:after, &:before" : {
                                top:"-0px"
                            }
                        }
                    }}
                // tabClasses={"btn-body-tab"}
            >
                {transformedData !== null &&
                    <>
                        <PortalSettings
                            data={data}
                            config={relationReturnsDesignConfig.returnportalsettings}
                        />
                        <ReturnCosts
                            config={relationReturnsDesignConfig.return_costs}
                        />
                        <ReturnReasons
                            config={relationReturnsDesignConfig.return_reasons}
                        />
                        <Vormgeving
                            config={relationReturnsDesignConfig.vormgeving}
                            transformedData={transformedData}
                            setTransformedData={setTransformedData}
                            saveDesign={saveDesign}
                            relationMenuData={data}
                            styleUpdating={styleUpdating}
                        />
                    </>
                }
            </TabView3>
        </Box>
    )
};

export default ReturnPortalDesignWarehouse;
